export const set_shop_point = 'set_shop_point';

export const setShopPoint = (point) => ({
    type: set_shop_point,
    data: point,
})